import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SiteTechnologyInfoGQL, SiteTechnologyInfoQuery } from './graphql-multitech-api';

@Injectable({ providedIn: 'root' })
export class SiteTechnologyInfoService {
  constructor(private siteTechnologyInfoGQL: SiteTechnologyInfoGQL) {}

  public getData(subassets: string[]): Observable<SiteTechnologyInfoQuery> {
    return this.siteTechnologyInfoGQL
      .fetch({ variables: { subassets }, fetchPolicy: 'no-cache' })
      .pipe(map(({ data }) => data));
  }
}
